module.exports = __webpack_public_path__ + "img/news3-1.c3f93ecb.png";